import React from "react";
import { Link } from "react-router-dom";

const GRIP_IMAGE =
  "https://customer-assets.emergentagent.com/job_grip-pitch/artifacts/0zrqinho_WhatsApp%20Image%202026-05-22%20at%2011.52.22.jpeg";

/**
 * GripSystem — home page showcase of the 8 grip patterns.
 * Mirrors the official 'Performance, From The Ground Up' chart but with hover
 * affordance, anchor IDs (for /shop deep-links) and a CTA to the product page.
 */
const GripSystem = ({ grips = [] }) => {
  if (!grips.length) return null;
  return (
    <section className="border-y border-line bg-chalk" data-testid="grip-system">
      <div className="container-x py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-12">
          <div className="md:col-span-7">
            <p className="overline mb-4">The Grip System</p>
            <h2 className="font-display uppercase text-4xl md:text-6xl tracking-tight font-bold leading-[0.95]">
              Eight grips.
              <br />
              <span className="text-mute">One signature feel.</span>
            </h2>
          </div>
          <div className="md:col-span-5 flex md:items-end">
            <p className="text-mute max-w-md leading-relaxed">
              Pritch grip patterns are engineered around how footballers actually move — sprint,
              cut, stop, strike. Pick the grip that matches your game.
            </p>
          </div>
        </div>

        <div className="bg-white border border-line p-4 md:p-8 mb-10">
          <img
            src={GRIP_IMAGE}
            alt="The Pritch grip system — eight performance patterns"
            className="w-full h-auto"
            data-testid="grip-system-image"
            loading="lazy"
          />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-line border border-line">
          {grips.map((g) => (
            <article
              key={g.slug}
              id={`grip-${g.slug}`}
              className="bg-white p-6 md:p-7 flex flex-col"
              data-testid={`grip-card-${g.slug}`}
            >
              <p className="mono text-xs text-mute">{g.no}</p>
              <h3 className="font-display uppercase text-xl tracking-tight font-bold mt-3 leading-[1]">
                {g.name}
              </h3>
              <p className="mt-3 text-sm font-medium leading-snug">{g.tagline}</p>
              <p className="text-sm text-mute leading-snug">{g.subline}</p>
              <p className="mt-4 text-xs text-mute leading-relaxed flex-1">{g.description}</p>
              <Link
                to={`/product/pritch-grip-sock?g=${g.slug}`}
                className="mt-5 inline-flex items-center text-[11px] tracking-[0.18em] uppercase font-bold border-t border-line pt-4 hover:gap-3 transition-all gap-2"
                data-testid={`grip-cta-${g.slug}`}
              >
                Build with {g.name.replace("Pritch ", "")} →
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GripSystem;
